module.exports = "../study/imgs/maps/Tokyo/S8/Helth/HeatDisorder/Tokyo_HeatDisorder_HadGEM2_RCP85_Now.png";